import { render } from "./ProductLoader.vue?vue&type=template&id=b1b49900"
import script from "./ProductLoader.vue?vue&type=script&lang=js"
export * from "./ProductLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__